import { faBoxCheck } from '@fortawesome/pro-solid-svg-icons';
import { HeadingItem } from 'components';
import { BarGauge, Geometry, Label, Legend, Margin, Size } from 'devextreme-react/bar-gauge';
import React, { FC, Fragment } from 'react';
import { VerifiedMethod } from 'services/enums';
import { LicensePlate, OrderItem } from 'services/types';
import './dashboard-overview-details.scss';

type DashBoardOverviewProps = {
    items: OrderItem[]
    lps: LicensePlate[]
}

export const DashboardOverviewDetails: FC<DashBoardOverviewProps> = ({ items, lps }) => {

    const verifiableItems = items.filter(item => (item.verifiedMethod != VerifiedMethod.SubjectToCount && item.verifiedMethod != VerifiedMethod.ZeroShipped) || item.verifiedMethod == null)
    const itemsVerified = verifiableItems.filter(item => item.verifiedMethod != null)
    const lpsVerified = lps.filter(lp => lp.verifiedMethod != null)

    let palette = []
    let gaugeData = []
    if (verifiableItems.length > 0) {
        palette.push('#EB5757')
        gaugeData.push(itemsVerified.length / verifiableItems.length)
    }
    if (lps.length > 0) {
        palette.push('#01AFF1')
        gaugeData.push(lpsVerified.length / lps.length)
    }

    const renderLegendText = (e: any) => {
        let label = ''
        if (verifiableItems.length > 0 && e.item.index === 0) {
            label = `Items: ${itemsVerified.length}`
        }
        else {
            label = `LPs: ${lpsVerified.length}`
        }
        return label
    }

    return (
        <Fragment>
            <div className={'overview-pie-chart'}>
                <HeadingItem leftHandIcon={{ icon: faBoxCheck, color: '#0066A4', size: '1x' }} text="Verified" />
                {gaugeData.length > 0 ?
                    <div className={'overview-pie-chart-center'}>
                        <BarGauge
                            startValue={0}
                            endValue={1}
                            values={gaugeData}
                            palette={palette}
                            backgroundColor={'#C2C2C2'}
                        >
                            <Size height={175} width={150} />
                            <Geometry startAngle={90} endAngle={90} />
                            <Margin top={15} />
                            <Label visible={false} />
                            <Legend
                                visible={true}
                                itemTextPosition={'bottom'}
                                verticalAlignment={'bottom'}
                                horizontalAlignment={'center'}
                                customizeText={renderLegendText}
                            />
                        </BarGauge>
                    </div>
                    :
                    <div>No data selected</div>
                }
            </div>
        </Fragment>
    )
}